<template>
    <div class="form-submission-card">
        <div class="col-12" v-if="loading">
            <loader/>
        </div>

		<div v-else-if="forms.length" class="form-submission-card-content">
            <div class="mb-3" v-for="form_group in forms">
                <h5 class="text-primary mb-2">{{form_group.date}}</h5>

                <div class="job-row-card no-hover w-100" v-for="form in form_group.data">
                    <h6 class="text-dark">{{form.title}}</h6>
                </div>
            </div>
		</div>
        <div class="mt-2 form-submission-card-content"  v-else >
            <h5>No upcoming forms</h5>
        </div>
    </div>
</template>

<script>
	import Loader from "../general_components/Loader";
	export default {
		name: "JobUpcomingComponent",
		components: {Loader},
		props: [
            'load_url',
        ],

        data(){
            return {
                loading: false,
                forms: [],
            }
        },

        mounted() {
            this.load();
        },

        methods: {
            load(){
                let _this = this;
                if (_this.loading){
                    return;
                }

                _this.loading = true;

                axios.get(_this.load_url)
                    .then(function (response){
                        _this.forms = response.data;
                        _this.loading = false;
                    });
            },

        }
	}
</script>
